__turbopack_context__.v({
  "Content": "ProjectTile-module-sass-module__E8AcSa__Content",
  "Image": "ProjectTile-module-sass-module__E8AcSa__Image",
  "Link": "ProjectTile-module-sass-module__E8AcSa__Link",
  "Main": "ProjectTile-module-sass-module__E8AcSa__Main",
  "ProjectCategory": "ProjectTile-module-sass-module__E8AcSa__ProjectCategory",
  "ProjectTile": "ProjectTile-module-sass-module__E8AcSa__ProjectTile",
  "SecondaryImage": "ProjectTile-module-sass-module__E8AcSa__SecondaryImage",
  "Title": "ProjectTile-module-sass-module__E8AcSa__Title",
  "Year": "ProjectTile-module-sass-module__E8AcSa__Year",
});
